import { Box, Chip } from "@mui/material";
import { useRecords } from "../../api/useRecords";
import { Clinic } from "../../types/records.types";

type OperationalCenter = {
    id: number;
    name: string;
    percentage: number;
};

type AllocationSummaryProps = {
    operationalCenters: Array<OperationalCenter>;
};

const OPERATIONAL_CENTER_LABELS: Record<string, string> = {
    clinic_porto: "Porto",
    clinic_braga: "Braga",
    global: "Global",
};

const GLOBAL_COLOR = "#546e7a";

const getClinicColor = (operationalCenterName: string, clinics: Array<Clinic>) => {
    if (operationalCenterName === "global") return GLOBAL_COLOR;

    const cityName = operationalCenterName.replace("clinic_", "");
    const matchingClinic = clinics.find((clinic) =>
        clinic.name.toLowerCase().includes(cityName.toLowerCase()),
    );
    const color = matchingClinic?.color || GLOBAL_COLOR;
    return color;
};

export const AllocationSummary = ({ operationalCenters }: AllocationSummaryProps) => {
    const { data: clinicsData } = useRecords("clinics", "id,name,color", { staleTime: Infinity });
    const clinics = (clinicsData?.items ?? []) as Array<Clinic>;

    if (!operationalCenters || operationalCenters.length === 0) return null;

    return (
        <Box display="flex" flexWrap="wrap" gap={0.5}>
            {operationalCenters.map((center) => {
                const label = OPERATIONAL_CENTER_LABELS[center.name] || center.name;
                const backgroundColor = getClinicColor(center.name, clinics);
                const displayLabel = `${label} ${center.percentage}%`;

                return (
                    <Chip
                        key={center.id}
                        label={displayLabel}
                        size="small"
                        sx={{
                            backgroundColor,
                            color: "#fff",
                            fontSize: "0.7rem",
                            height: 22,
                            fontWeight: 500,
                        }}
                    />
                );
            })}
        </Box>
    );
};
